/* eslint-disable no-restricted-globals */

import Vue from '@/system/main';

export default {
	parseSerial(item) {
		let preffix = item.SeriePrefijo || '';
		const value = item.SerieValor || '';
		let suffix = item.SerieSufijo || '';

		const alert = [false, false];

		const vars = {
			'%YYYY': Vue.$moment().format('YYYY'),
			'%MM': Vue.$moment().format('MM')
		};

		Object.keys(vars).forEach((k) => {
			preffix = preffix.replace(k, vars[k]);
			suffix = suffix.replace(k, vars[k]);
		});

		if (preffix && !isNaN(preffix.charAt(preffix.length - 1))) {
			alert[0] = true;
		}

		if (suffix && !isNaN(suffix.charAt(0))) {
			alert[1] = true;
		}

		return {
			serial: preffix + value + suffix,
			alert: !!((alert[0] || alert[1]))
		};
	},
	async editSerialValue(serie, mode = 'up', quiet = true) {
		const getSerie = await Vue.$gestios.items('series').get(serie._EntityId);

		if (getSerie.ok) {
			const value = getSerie.data.SerieValor;

			let newValue = (value + 1);
			if (mode === 'down') newValue = (value - 1);

			const result = await Vue.$gestios.items('series').edit({
				id: serie._EntityId,
				params: {
					SerieValor: newValue
				}
			});

			if (result.ok) {
				if (!quiet) Vue.$toast.success(`Nº de serie ${mode === 'down' ? 'reducido' : 'incrementado'} a ${(newValue)}`);
				return true;
			}
		}

		Vue.$toast.error(`No se pudo modificar el valor numérico de la serie ${serie.SerieNombre}`);
		return false;
	},
	async getSerialValue(id) {
		const result = await Vue.$gestios.items('series').get(id);

		if (result.ok) {
			return result.data;
		}

		return false;
	}
};
